import Cookies from 'js-cookie';
import apiClient from 'services/_infra/apiClient';
import { tryCache } from 'services/_infra/requestCache';

export async function getExtendedFireDanger() {
  try {
    const res = await tryCache(
      `getExtendedFireDanger-${Cookies.get('latitude')}-${Cookies.get('longitude')}`,
      () =>
        apiClient.post('/getExtendedFireDanger', {
          city: Cookies.get('city'),
          state: Cookies.get('state'),
          latitude: Cookies.get('latitude'),
          longitude: Cookies.get('longitude'),
        }),
    );
    return res;
  } catch (error) {
    console.error('GetExtendedFireDanger error:', error);
  }
}

export async function getDetailedFireDanger() {
  try {
    const res = await tryCache(
      `getDetailedFireDanger-${Cookies.get('latitude')}-${Cookies.get('longitude')}`,
      () =>
        apiClient.post('/getDetailedFireDanger', {
          city: Cookies.get('city'),
          state: Cookies.get('state'),
          latitude: Cookies.get('latitude'),
          longitude: Cookies.get('longitude'),
        }),
    );
    return res;
  } catch (error) {
    console.error('getDetailedFireDanger failed.', error);
  }
}
